import { isTestcafeEnabled } from '@/services/testCafe'
import type { ApiEndpoints } from '@/types/backend'
import type { TODO } from '@/types/utils'

type Params = {
  [key: string]: TODO
}

class Endpoints {
  private readonly apiPrefix: string

  constructor() {
    this.apiPrefix = isTestcafeEnabled()
      ? import.meta.env.VITE_API_BASE_TESTCAFE_URL
      : import.meta.env.VITE_API_BASE_URL

    this.apiPrefix += 'v1/'
  }

  get(endpointLabel: ApiEndpoints, params?: Params): string {
    let url = endpointLabel as string

    if (typeof params === 'object') {
      for (const param in params) {
        url = url.replace(':' + param, params[param])
      }
    } else if (url.indexOf('/:') > 0) {
      url = url.substring(0, url.indexOf('/:'))
    }

    return this.apiPrefix.concat(url)
  }
}

export default new Endpoints()
